import { ErrorComponentProps } from '@ferreri/minato-error-handler-react';
import { ModalError } from '@ferreri/prever-component-lib';
import { useState } from 'react';

export const PlanVersionHasPendingDataError = ({
  error,
  hideError,
}: ErrorComponentProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleCloseModal = () => {
    setIsOpen(false);
    hideError();
  };

  return (
    <ModalError
      title="Pendência para publicar versão"
      isOpen={isOpen}
      hasCloseButton
      onClose={handleCloseModal}
      onCloseClick={handleCloseModal}
      error={error}
      description="Para publicar esta versão é necessário: que todos os dados em ”Informações da versão” estejam preenchidos, que pelo menos um benefício seja incluído e que o PDF de contrato do plano seja adicionado."
      labelButtonPrimary="Revisar informações"
      onClickButtonPrimary={handleCloseModal}
    />
  );
};
